import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const CustomerAuthContext = createContext(null);
export const useCustomerAuth = () => useContext(CustomerAuthContext);

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null); // null = checking, false = logged out, object = logged in

  const check = useCallback(() => {
    api.get("/customer/auth/me")
      .then((r) => { localStorage.setItem("pnp_customer", "1"); setCustomer(r.data); })
      .catch(() => { localStorage.removeItem("pnp_customer"); setCustomer(false); });
  }, []);

  useEffect(() => {
    // CRITICAL: returning from OAuth callback — skip the /me check so AuthCallback
    // can exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) { setCustomer(false); return; }
    // Skip the /me request (and its 401 console noise) for visitors who never signed in.
    if (!localStorage.getItem("pnp_customer")) { setCustomer(false); return; }
    check();
  }, [check]);

  const startLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try { await api.post("/customer/auth/logout"); } catch (e) { console.debug("customer logout failed", e?.message); }
    localStorage.removeItem("pnp_customer");
    setCustomer(false);
  };

  return (
    <CustomerAuthContext.Provider value={{ customer, setCustomer, check, startLogin, logout }}>
      {children}
    </CustomerAuthContext.Provider>
  );
}
